import { Injectable } from '@angular/core';
import { HttpService } from '@core/services/http/http.service';
import { URLParamsService } from '@shared/services/url-params.service';
import { Locality } from '@shared/models/localty.model';
import { LocalityNew } from '@shared/models/localty-new.model';
import { Observable } from 'rxjs';


@Injectable()
export class NeighborhoodService {
  static readonly url = 'Neighborhood/';

  constructor(private httpService: HttpService) { }

  getLocalities(): Observable<Locality[]> {
    const url = URLParamsService.buildUrl(`${NeighborhoodService.url}GetLocalities`, null);
    return this.httpService.GetRequest<Locality[]>(url);
  }

  getNeighborhoodsForBranch(BranchID: number): Observable<Locality[]> {
    const url = URLParamsService.buildUrl(`${NeighborhoodService.url}GetNeighborhoodsForBranch`, {
      BranchID: BranchID,
    });
    return this.httpService.GetRequest<Locality[]>(url);
  }

  saveLocalityForBranch(localityNew: LocalityNew): Observable<any> {
    const url = `${NeighborhoodService.url}SaveLocalityForBranch`;

    return this.httpService.PostRequest<LocalityNew, any>(url, localityNew);
  }

  deleteNeighborhood(localty: LocalityNew): Observable<any> {
    const url = `${NeighborhoodService.url}DeleteNeighborhood`;

    return this.httpService.DeleteRequest<LocalityNew, any>(url, localty);
  }
}
